define('modules/private/view-mdheader',['require','exports','module','jquery','backbone','i18n','env','./authInfo','react','react-dom','mdheaderjs','./view-mdsidebar','ThemesHelper','modules/accounts/groups/index'],function (require, exports, module) {
  "use strict";

  var $ = require("jquery"),
    Backbone = require("backbone"),
    i18n = require("i18n"),
    Config = require("env"),
    AuthInfo = require("./authInfo"),
    React = require("react"),
    ReactDOM = require("react-dom"),
    MDHeader = require("mdheaderjs"),
    MDSidebarJS = require("./view-mdsidebar"),
    ThemesHelper = require("ThemesHelper"),
    Groups = require("modules/accounts/groups/index");

  var MDHeaderJS = Backbone.View.extend({
    group: null,
    initialize: function (options) {
      var self = this;
      this.options = options;
      if (this.model) {
        this.listenTo(this.model, "sync", this.loadData);
      }
    },

    loadData: function () {
      var self = this;
      this.group = new Groups.Model({
        id: this.model.getGroup(),
      });
      this.group.fetch({
        success: function (model, response) {
          self.render();
        },
      });
    },

    showCompanies: function () {
      return true;
    },

    getExtraItems: function () {
      var defaultItems = [];

      return defaultItems;
    },

    render: function () {
      var self = this;
      var headerContainer = document.getElementById("header");

      if (!headerContainer) {
        return;
      }

      var authInfo = new AuthInfo(this.model);
      var headerOptions = {
        theme: ThemesHelper.getCurrentTheme(),
        authInfo: authInfo,
        extraItems: this.getExtraItems(),
        lang: i18n.lng(),
        showCompanies: this.showCompanies(),
        onChangeLanguage: function (lang) {
          i18n.setLng(lang, function () {
            self.render();
          });
          new MDSidebarJS({
            model: self.model,
            el: "#md__sidebar__wrapper",
          })
            .setUserLang(lang)
            .loadServices();
        },
        openSupportChat: null,
        logoutUrl: Config.backendUrl + "/auth/logout",
        myAccountUrl: this.model.isAdm() ? "/accounts" : "/accounts/user/me",

        onChangeCompany: function (empId) {
          Config.setCompanyId(empId);
          authInfo.setCompanyData(empId);
          self.render();
          new MDSidebarJS({
            model: self.model,
            el: "#md__sidebar__wrapper",
          }).loadServices();
        },
        properties: {
          isAppSumo: !this.group ? false : this.group.isAppSumo(),
        },
      };

      ReactDOM.render(
        React.createElement(MDHeader, headerOptions),
        document.getElementById("header")
      );

      if (this.options.afterRenderCallback) {
        this.options.afterRenderCallback();
      }

      $("html").i18n();
    },
    showHeader: function () {
      $("#header").show();
    },
  });

  module.exports = MDHeaderJS;
});

